import { BasicService } from "./core/basic.service";

export class ArticleService extends BasicService {
    //文章列表
    static async getList(query,pageQuery) {
        const data = await this.http.post('/article/index',{...query,...pageQuery});
        data.list.data.forEach(item => {
            item.is_enable = !!item.is_enable
            item.is_home_recommended = !!item.is_home_recommended
            data.cat_list.forEach(i => {
                if(i.id === item.article_category_id) {
                    item.article_category_name = i.name
                }
            })
        });
        return Promise.resolve(data);
    } 
    static async getListCascader() {
        const data = await this.http.post('/article/index')
        data.cat_list.forEach(i => {
            i.children = []
            i.sub = []
        })
        data.list.data.forEach(item => {
            
            item.is_enable = !!item.is_enable
            item.is_home_recommended = !!item.is_home_recommended
            data.cat_list.forEach(i => {
                if(i.id === item.article_category_id) {
                    item.value = item.id 
                    item.label = item.title
                    item.name = item.title
                    i.children.push(item)
                    i.sub.push(item)
                }
                i.value = i.id
                i.label = i.name
            })
        });
        return Promise.resolve(data)
    }
    static async swichArticleStatus( id,is_enable ) {
        const data = await this.http.post('/article/isEnable',{ id,is_enable })
        return Promise.resolve(data)
    }
    static async swichArticleRecommendStatus( id,is_home_recommended ) {
        const data = await this.http.post('/article/isRecommend',{ id,is_home_recommended })
        return Promise.resolve(data)
    }
    static async submitArticle(query) {
        const data = await this.http.post('/article/save',query)
        return Promise.resolve(data)
    }
    static async delArticle(id) {
        const data = await this.http.post('/article/del',{ id })
        return Promise.resolve(data)
    }
    static async getArticleDetail(id) {
        const data = await this.http.post('/article/detail',{ id })
        return Promise.resolve(data)
    }
    //文章分类管理
    static async getClassficationList() {
        const data = await this.http.post('/Article_cat/index')
        data.forEach(item => {
            item.is_enable = !!item.is_enable
        });
        return Promise.resolve(data)
    }
    static async getClassficationListDetail( id ) {
        const data = await this.http.post('/Article_cat/detail',{ id })
        return Promise.resolve(data)
    }
    static async submitArticleClassification(query) {
        const data = await this.http.post('/Article_cat/save',query)
        return Promise.resolve(data)
    }
    static async delArticleClassification(id) {
        const data = await this.http.post('/Article_cat/del',{ id })
        return Promise.resolve(data)
    }
}